import React from "react";

const BRANDS = [
  { name: "DAIKIN", url: "/uploads/brands/daikin.jpg" },
  { name: "MITSUBISHI Electric", url: "/uploads/brands/mitsubishi.jpg" },
  { name: "HITACHI", url: "/uploads/brands/hitachi.png" },
  { name: "HEIWA", text: true },
];

const ALL = [...BRANDS, ...BRANDS, ...BRANDS];

export default function BrandsSection() {
  return (
    <section className="py-12 md:py-14 bg-white border-y border-[hsl(var(--border))]" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-8">
          <div className="text-xs md:text-sm uppercase tracking-[0.25em] text-[color:var(--brand-sky)] font-semibold mb-2">
            Marques partenaires
          </div>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-[color:var(--brand-navy)]">
            Nous installons les leaders mondiaux
          </h2>
        </div>
      </div>
      <div className="relative overflow-hidden">
        <div className="flex gap-12 md:gap-20 animate-marquee whitespace-nowrap py-4 items-center" style={{ width: "max-content" }}>
          {ALL.map((b, i) => (
            <div
              key={i}
              className="flex items-center justify-center min-w-[140px] md:min-w-[180px] h-16 md:h-20 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all"
              title={b.name}
            >
              {b.text ? (
                <span className="font-display font-black text-2xl md:text-3xl text-[color:var(--brand-navy)] tracking-[0.2em]">{b.name}</span>
              ) : (
                <img
                  src={b.url}
                  alt={b.name}
                  className="max-h-12 md:max-h-16 w-auto object-contain"
                  loading="lazy"
                />
              )}
            </div>
          ))}
        </div>
        <div className="absolute top-0 left-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-white to-transparent pointer-events-none" />
        <div className="absolute top-0 right-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </section>
  );
}
